export class AuditSampleModel {
    seedNumber: number;
    numberOfSamples: number;

    sampleType: number;

    testPopulationSize: number;
    startDate: Date;
    endDate: Date;
}